import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQ_ITEMS } from "../data/pricing";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-slate-50 py-24 lg:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <span className="text-xs uppercase tracking-[0.22em] text-amber-700 font-semibold">
            FAQ
          </span>
          <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight">
            Časté otázky
          </h2>
          <p className="font-body mt-5 text-slate-600 text-lg">
            Pokud nenajdete odpověď, klidně zavolejte Lence.
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {FAQ_ITEMS.map((item, idx) => {
            const isOpen = idx === openIdx;
            return (
              <div
                key={item.q}
                data-testid={`faq-item-${idx}`}
                className="rounded-2xl border border-slate-200 bg-white overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  data-testid={`faq-toggle-${idx}`}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left"
                >
                  <span className="font-heading text-base sm:text-lg font-semibold text-slate-900">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={[
                      "h-5 w-5 shrink-0 text-slate-500 transition-transform duration-300",
                      isOpen ? "rotate-180 text-amber-600" : "",
                    ].join(" ")}
                  />
                </button>
                <div
                  className={[
                    "grid transition-all duration-300 ease-out",
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0",
                  ].join(" ")}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-slate-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
